import { faBuildingUser, faGears, faHome, faMobile, faUsers, faUsersGear } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RutasPrivadas } from '../../../routes/rutasPrivadas/rutasPrivadas';
import { CerrarSesion } from '../CerrarSesion';
import { Link } from 'react-router-dom';

export type SidebarProps = {
	isSidebarOpen: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({ isSidebarOpen }) => {

	return (
		<div className="border-r bg-white">
			{/* Sidebar-Desktop */}
			<div className='lg:block md:hidden hidden lg:w-64 h-screen'>
				<div className={`flex flex-col justify-between items-start`}>
					<div className='flex-grow gap-1'>
						<ul className='menu px-4 py-4 gap-2 '>
							<li>
								<Link to="/" className="flex items-center">
									<FontAwesomeIcon icon={faHome} color='#20244a'/>
									<p className=' text-DarkText font-semibold'>Inicio</p>
								</Link>
							</li>
							<li>
								<details className='w-56'>
									<summary>
										<span className='flex gap-2 items-center'>
											<FontAwesomeIcon icon={faUsersGear} />
											<p className=' text-DarkText font-semibold'>Gestión de usuarios</p>
										</span>
									</summary>
									<ul>
										<li>
											<Link to={`/${RutasPrivadas.PRIVATE}/${RutasPrivadas.NUEVOS_USUARIOS}`} className="flex items-center">
												<FontAwesomeIcon
													icon={faUsers}
													className="md:h-3 h-5 m-2"
												/>
												<h1 className=''>Nuevos usuarios</h1>
											</Link>
										</li>
										<li>
											<Link to={`/${RutasPrivadas.PRIVATE}/${RutasPrivadas.TODOS_USUARIOS}`} className="flex items-center">
												<FontAwesomeIcon
													icon={faUsersGear}
													className="md:h-3 h-5 m-2"
												/>
												<h1 className=''>Todos los usuarios</h1>
											</Link>
										</li>
									</ul>
								</details>
							</li>
							<li>
								<details className='w-56'>
									<summary>
										<span className='flex gap-2 items-center'>
											<FontAwesomeIcon icon={faBuildingUser} />
											<p className=' text-DarkText font-semibold'>Empresas</p>
										</span>
									</summary>
									<ul>
										<li>
											<Link to={`/${RutasPrivadas.PRIVATE}/${RutasPrivadas.EMPRESAS}`} className="flex items-center">
												<FontAwesomeIcon
													icon={faMobile}
													className="md:h-3 h-5 m-2"
												/>
												<h1 className=''>Gestión de empresas</h1>
											</Link>
										</li>
									</ul>
								</details>
							</li>
							<li className='absolute bottom-10 left-10'>
								<CerrarSesion />
							</li>
						</ul>
					</div>
				</div>
			</div>
			{/* Sidebar-Movil */}
			<div className={`lg:hidden h-screen absolute z-50 ${isSidebarOpen ? 'transform translate-x-[0%] transition-all bg-white w-full' : 'transform -translate-x-full transition-all'}`}>
				<div className={`flex flex-col justify-between items-start ${isSidebarOpen ? 'w-screen' : ''} justify-between items-start`}>
					<div className='flex-grow gap-1'>
						<div className='h-4'></div>
						<ul className='menu px-4 py-4 gap-2 '>
							<li>
								<Link to="/" className="flex items-center">
									<FontAwesomeIcon icon={faHome} color='#20244a'/>
									<p className=' text-DarkText font-semibold'>Inicio</p>
								</Link>
							</li>
							<li>
								<details className='w-56'>
									<summary>
										<span className='flex gap-2 items-center'>
											<FontAwesomeIcon icon={faUsersGear} />
											<p className=' text-DarkText font-semibold'>Gestión de usuarios</p>
										</span>
									</summary>
									<ul>
										<li>
											<Link to={`/${RutasPrivadas.PRIVATE}/${RutasPrivadas.NUEVOS_USUARIOS}`} className="flex items-center">
												<FontAwesomeIcon
													icon={faUsers}
													className="md:h-3 h-5 m-2"
												/>
												<h1 className=''>Nuevos usuarios</h1>
											</Link>
										</li>
										<li>
											<Link to={`/${RutasPrivadas.PRIVATE}/${RutasPrivadas.TODOS_USUARIOS}`} className="flex items-center">
												<FontAwesomeIcon
													icon={faUsersGear}
													className="md:h-3 h-5 m-2"
												/>
												<h1 className=''>Todos los usuarios</h1>
											</Link>
										</li>
									</ul>
								</details>
							</li>
							<li>
								<details className='w-56'>
									<summary>
										<span className='flex gap-2 items-center'>
											<FontAwesomeIcon icon={faBuildingUser} />
											<p className=' text-DarkText font-semibold'>Empresas</p>
										</span>
									</summary>
									<ul>
										<li>
											<Link to={`/${RutasPrivadas.PRIVATE}/${RutasPrivadas.EMPRESAS}`} className="flex items-center">
												<FontAwesomeIcon
													icon={faMobile}
													className="md:h-3 h-5 m-2"
												/>
												<h1 className=''>Gestión de empresas</h1>
											</Link>
										</li>
									</ul>
								</details>
							</li>
							<li className='absolute bottom-10 left-10'>
								<CerrarSesion />
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Sidebar;
